import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Col, Image } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroller';
import { useAuth } from '../../auth/Auth';
import CampHeader from '../../header/CampHeader';
import CampHeaderGuest from '../../header/CampHeaderGuest';
import { nextChallengeViewModel } from './next.challenge.viewmodel';
import NextChallengeList from './NextChallengeList';
import TagSelectbox from '../../common/TagSelectbox';
import {
  CHALLENGE_ROUTE,
  EVENT_ROUTE,
  SPECIAL_CHALLENGE_ROUTE,
} from '../../../constants/routes.constants';
import LeftSideBar from '../../common/LeftSideBar';
import RightSideBar from '../../common/RightSideBar';
import './scss/next.challenge.scss';
import TaletreeLoader from '../taletree_loader/TaletreeLoader';
import OptimizeSignup from '../onboarding/signup_popups/OptimizeSignup';
import { handleScrollToTop } from '../../../utils/utils';
import ConnectCampModal from '../../common/ConnectCampModal';
import ChallengesFilter from './filter/ChallengesFilter';

const NextChallenges = (props, { challenge }) => {
  const _PAGE_LIMIT = 10;
  const _ALL = 'all';
  const _MOSTPOPULAR = 'most_popular';
  const _TAG = 'tag';
  const _MYCAMP = 'my_camp';
  const history = useHistory();
  const location = useLocation();
  const { dependent, guardian, school, fetchAPI } = useAuth();
  const [challengeList, setChallengeList] = useState(null);
  const [eventList, setEventList] = useState([]);
  const [remainEventList, setRemainEventList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rightCollapsse, setRightCollapsse] = useState('');
  const [leftCollapsse, setLeftCollapsse] = useState('');
  const [zoomClass, setZoomClass] = useState('');
  const tagsFilter = JSON.parse(localStorage.getItem("tagsFilter"))
  const [query, setQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
    tags: tagsFilter && tagsFilter?.tag ? tagsFilter?.tag : '',
  });
  const [eventQuery, setEventQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
  });
  const [tagList, setTagList] = useState([]);
  const [selectedTag, setSelectedTag] = useState(
    tagsFilter ? tagsFilter?.tag : []
  );
  const [selectedFilter, setSelectedFilter] = useState(
    tagsFilter
      ? tagsFilter?.filter
      : _MOSTPOPULAR
  );
  const [allSelected, setAllSelected] = useState(true);
  const [mostPopularSelected, setMostPopularSelected] = useState(false);
  const [tagSelected, setTagSelected] = useState(false);
  const [myCampSelected, setMyCampSelected] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showCampModal, setShowCampModal] = useState(false);
  // set selected filter
  useEffect(() => {
    setAllSelected(selectedFilter === _ALL);
    setMostPopularSelected(selectedFilter === _MOSTPOPULAR);
    setMyCampSelected(selectedFilter === _MYCAMP);
    setTagSelected(selectedFilter.split('_')[0] === _TAG);
    if (!isLoading) getChallenges();
    if (eventList === null || eventList.length === 0) {
      if (selectedFilter === _ALL) getEvents();
    }
  }, [selectedFilter]);

  useEffect(() => {
    if (tagSelected) {
      setChallengeList(null);
      if (allSelected) setEventList(null);
    }
  }, [tagSelected]);

  // get all tags
  const getTagList = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 99 })
      .then((res) => {
        setTagList([...res]);
      })
      .catch((err) => { });
  };

  const getChallenges = () => {
    setIsLoading(true);
    const previousChallengeList = challengeList;
    const filterStr =
      selectedFilter.split('_')[0] === _TAG
        ? _ALL
        : selectedFilter === _MYCAMP
          ? _ALL
          : selectedFilter;

    let params;
    if (dependent || guardian) {
      params = {
        ...query,
        dependent_id: dependent
          ? dependent.id
          : guardian
            ? localStorage.getItem('set_dependent_id')
              ? localStorage.getItem('set_dependent_id')
              : ''
            : '',
      };
    } else {
      params = { ...query };
    }

    fetchAPI(
      selectedFilter === _MYCAMP
        ? nextChallengeViewModel.getPrivateMyCampChallenges
        : nextChallengeViewModel.getPrivateChallenges,
      filterStr,
      params,
      previousChallengeList
    )
      .then((data) => {
        ReactDOM.unstable_batchedUpdates(() => {
          setChallengeList(data.challengeList);
          setQuery(data.query);
        });
        setIsLoading(false);
      })
      .catch((error) => {
        // addError(error.data.message)
        // setLoading(false);
      });
  };

  const getEvents = () => {
    const params = { ...eventQuery };
    const previousEventList = eventList;
    fetchAPI(nextChallengeViewModel.getEvents, params, previousEventList)
      .then((data) => {
        setEventList(data.eventList);
        setEventQuery(data.query);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getInfiniteChallenges = () => {
    if (!isLoading) getChallenges();
    if (eventList === null || eventList.length === 0) {
      if (selectedFilter === _ALL) getEvents();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location?.state?.from === 'map') {
      setTimeout(() => {
        setZoomClass('page-loaded zoom-in');
      }, 300);
    }
  }, []);

  const onItemClick = (e, isEvent) => {
    const index = challengeList.findIndex((x) => {
      return x.id === parseInt(e.target.id, 10);
    });
    let path;
    let encodeQuery;
    if (isEvent === 'challenge') {
      path = CHALLENGE_ROUTE;
      encodeQuery = btoa(`{"id":${e.target.id}, "slug":"challenge"}`);
    }
    if (isEvent === 'special') {
      path = SPECIAL_CHALLENGE_ROUTE;
      encodeQuery = btoa(`{"id":${e.target.id}, "slug":"special-challenge"}`);
    }
    if (isEvent === 'event') {
      path = EVENT_ROUTE;
      encodeQuery = btoa(`{"id":${e.target.id}, "slug":"event"}`);
    }
    history.push({
      pathname: path,
      search: `?encrypt=${encodeQuery}`,
      state: {
        filter: selectedFilter,
        selectedTag: selectedTag,
        challenge: challengeList[index],
      },
    });
    window.scrollTo(0, 0);
  };

  const onMyCampClick = () => {
    if (!dependent && !guardian) {
      if (!dependent && !guardian && !school) {
        setShowModal(true);
      }
      return;
    }
    if (dependent && !dependent?.profile?.group?.id) {
      return setShowCampModal(true);
    }
    setChallengeList(null);
    setEventList(null);
    setQuery((prevStat) => {
      const p = {
        ...prevStat,
        starting_after: 0,
        group_id: dependent?.profile?.group?.id,
        camp_id: dependent?.school_details?.id,
      };
      delete p.tags;
      return p;
    });
    setSelectedFilter(_MYCAMP);
    setSelectedTag([]);
  };

  const showAll = (e) => {
    if (!dependent && !guardian) {
      if (!dependent && !guardian && !school) {
        setShowModal(true);
      }
      return;
    }
    if (allSelected || isLoading) return;
    setChallengeList(null);
    setEventList(null);
    setQuery((prevStat) => {
      const p = {
        ...prevStat,
        starting_after: 0,
      };
      delete p.tags;
      delete p.group_id;
      delete p.camp_id;
      return p;
    });
    setSelectedFilter(_ALL);
    setSelectedTag([]);
  };

  const showMostPopular = (e) => {
    if (mostPopularSelected || isLoading) return;
    setChallengeList(null);
    setEventList(null);
    setQuery((prevStat) => {
      const p = {
        ...prevStat,
        starting_after: 0,
      };
      delete p.tags;
      delete p.group_id;
      delete p.camp_id;
      return p;
    });
    setSelectedFilter(_MOSTPOPULAR);
    setSelectedTag([]);
  };

  const showListWithTag = (e) => {
    setChallengeList(null);
    setEventList(null);
    setQuery((prevStat) => {
      const p = {
        ...prevStat,
        tags: selectedTag,
        starting_after: 0,
      };
      delete p.group_id;
      delete p.camp_id;
      return p;
    });
    setSelectedFilter(`${_TAG}_${selectedTag}`);
  };

  const handleClick = (e) => {
    if (!dependent) {
      if (!dependent && !guardian && !school) {
        setShowModal(true);
      }
      return;
    } else {
      console.warn('Not a User');
      const tag = e.target.dataset.tag;
      if (selectedTag === tag || isLoading) return;
      setSelectedTag(tag);
      setChallengeList(null);
      setEventList(null);
      setQuery((prevStat) => {
        const p = {
          ...prevStat,
          tags: tag,
          starting_after: 0,
        };
        delete p.group_id;
        delete p.camp_id;
        return p;
      });
      setSelectedFilter(`${_TAG}_${tag}`);
    }
  };

  useEffect(() => {
    getTagList();
    setChallengeList(null);
    setEventList(null);
    localStorage.removeItem('partner');
  }, []);

  const onBranchClick = (e) => {
    if (selectedTag === e || isLoading) return;
    localStorage.setItem("tagsFilter",JSON.stringify({tag:e,filter:'tag'}))
    setSelectedTag(e);
    setChallengeList(null);
    setEventList(null);
    setQuery((prevStat) => ({
      ...prevStat,
      tags: e,
      starting_after: 0,
    }));
    setSelectedFilter(`${_TAG}_${e}`);
  };

  const handleWoodenBannerClick = () => {
    handleScrollToTop();
  };

  return (
    <>
      {/* {dependent && !guardian && <CompanionPrompt />} */}
      <div className={`challenges-flex-wrapper ${zoomClass}`}>
        {dependent && !guardian ? (
          <CampHeader
            leftCollapsse={leftCollapsse}
            rightCollapsse={rightCollapsse}
          />
        ) : (
          <CampHeaderGuest
            leftCollapsse={leftCollapsse}
            rightCollapsse={rightCollapsse}
          />
        )}
        <div className="flex-wrapper">
          <LeftSideBar
            rightCollapsse={rightCollapsse}
            myInterests={true}
            setLeftCollapsse={setLeftCollapsse}
            branchClick={onBranchClick}
            setShowModal={setShowModal}
          />

          <div
            className={
              'flex-col-center challenge-list-container ' +
              rightCollapsse +
              ' ' +
              leftCollapsse
            }
          >
            <ChallengesFilter
              onMyCampClick={onMyCampClick}
              onShowAllClick={showAll}
              onShowMostPopularClick={showMostPopular}
              tagList={tagList}
              selectedFilter={selectedFilter.split('_')[0]}
              selectedTag={selectedTag}
              setSelectedTag={setSelectedTag}
              selected={tagSelected}
              showListWithTag={showListWithTag}
              myCampSelected={myCampSelected}
              allSelected={allSelected}
              mostPopularSelected={mostPopularSelected}
              tagSelected={tagSelected}
            />
            <div className="justify-content-md-center">
              <Col>
                <InfiniteScroll
                  pageStart={0}
                  loadMore={getInfiniteChallenges}
                  hasMore={query.has_more}
                  // hasMore={true}
                  loader={
                    // <Spinner key={0} animation="border" variant="info" />
                    <TaletreeLoader className="challenge-loader-wrapper" />
                  }
                  threshold={150}
                  initialLoad={false}
                >
                  {challengeList && (
                    <NextChallengeList
                      repos={challengeList}
                      eventList={eventList}
                      setEventList={setEventList}
                      remainEventList={remainEventList}
                      setRemainEventList={setRemainEventList}
                      handler={onItemClick}
                    />
                  )}
                </InfiniteScroll>
              </Col>
            </div>
          </div>

          <RightSideBar
            leftCollapsse={leftCollapsse}
            setRightCollapsse={setRightCollapsse}
            isNewChallengesButton={false}
          />
          <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
          <ConnectCampModal
            showModal={showCampModal}
            setShowModal={setShowCampModal}
          />
        </div>
      </div>
    </>
  );
};

export default NextChallenges;
